import { createContext } from '@chakra-ui/react-utils';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { VideoJsPlayer } from 'video.js';

type ILecturePlayerState = VideoJsPlayer | null;

type LecturePlayerContext = [ILecturePlayerState, Dispatch<SetStateAction<ILecturePlayerState>>];

export const [LecturePlayerProvider, useLecturePlayerContext] = createContext<LecturePlayerContext>({
  strict: true,
  name: 'LecturePlayerContext',
  errorMessage:
    'useLecturePlayerContext: `context` is undefined. Seems you forgot to wrap modal components in `<LecturePlayerProvider />`',
});

export interface ILecturePlayer {
  children: ReactNode;
}
